import styled from 'styled-components';
import React from 'react';
import i18n from '@/utils/i18n';

const BannerContainer = styled.div`
  max-width: 430px;
  border-radius: 3px;
  display: flex;
  padding: 10px 15px 10px 10px;
  align-items: flex-start;
`;

const BannerContent = styled.div`
  margin-left: 1rem;
  color: black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .title {
    font-weight: bold;
  }
`;

const PreoderImage = styled.img`
  width: 100px;
`;

const cityManagerEmails = {
  // "poi_city_417rbzi72odf33cyhh5r": "Julia@vytal.org",
  // "poi_city_ix5d7xl7v4ggd4f36eoa": "Katharina@vytal.org",
  // "poi_city_8bvhphrnci2l34f06790": "Klara@vytal.org",
  // "poi_city_o1ogxyh3qboxdsw9gl30": "Laura@vytal.org",
  // "poi_city_dw4um5u8eadzpnabbk5r": "Melanie@vytal.org",
};

export function PreorderPartnerBanner({ cityId = '' }) {
  const email = cityManagerEmails[cityId] || 'preorder@vytal.org';

  return (
    <BannerContainer className="bg-white p-3">
      <PreoderImage src="/preorder_icon.png" />
      <BannerContent>
        <h5 className="title">{i18n.t('OrderSetting:activatePreorder')}</h5>
        <span>{`${i18n.t('OrderSetting:contactNow')}: ${email}`}</span>
      </BannerContent>
    </BannerContainer>
  );
}
